import { defineComponent as a, inject as n, createElementBlock as o, openBlock as r, unref as i, normalizeClass as c, renderSlot as d } from "vue";
import { D as l } from "./DescriptionList.keys-BHlHYV6b.js";
const p = ["data-variant"], h = /* @__PURE__ */ a({
  __name: "DescriptionListDetail",
  setup(m) {
    const t = n(l.key);
    if (!t)
      throw new Error("DescriptionListDetail must be used within a DescriptionList component.");
    const { variant: e } = t;
    return (s, _) => (r(), o("dd", {
      class: c(["stash-description-list-detail tw-flex-1 tw-text-ice-700", {
        "md:tw-text-right": i(e) === "space-between"
      }]),
      "data-test": "stash-description-list-detail",
      "data-variant": i(e)
    }, [
      d(s.$slots, "default")
    ], 10, p));
  }
});
export {
  h as default
};
//# sourceMappingURL=DescriptionListDetail.js.map
